"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eSkinAeExcessLengthMap = void 0;
// ExcessLength values vor e-skin serie
exports.eSkinAeExcessLengthMap = new Map([
    ['SKS20', 30],
    ['SK28', 42],
    ['SKS28', 42],
    ['SKY28', 42],
    ['SK40', 42],
    ['SKS40', 42],
    ['SKY40', 42],
]);
//# sourceMappingURL=eSkinAeExcessLengthMap.js.map